import { NO_CACHE } from './constants';
import { factory } from './app';
import { OPEN } from '../../../common/const/access-level';

factory('grecaptcha', [
  '$window',
  '$timeout',
  'PublicStorageService',
  function($window, $timeout, PublicStorageService) {
    return async () => {
      let grecaptcha = $window.grecaptcha;

      if (grecaptcha) {
        return grecaptcha;
      }

      const { data: recaptchaConfig } = await PublicStorageService.getSiteKeys();

      async function injectRecaptcha(key) {
        var recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/enterprise.js?render=${key}`);
        let resolve, reject;
        const P = new Promise((res, rej) => {
          resolve = res;
          reject = rej;
        });
        recaptchaScript.onload = resolve;
        recaptchaScript.onerror = reject;
        document.head.append(recaptchaScript);

        return P;
      }

      const key = recaptchaConfig.enterpriseCaptchaKey;

      // needed to allow recaptcha injection to complete
      await injectRecaptcha(key);

      grecaptcha = await $timeout(
        () => {
          return $window.grecaptcha;
        },
        500 //delay
      );

      return grecaptcha;
    };
  }
]);

factory('httpWithRecaptcha', [
  '$http',
  'grecaptcha',
  'PublicStorageService',
  'AccessLevel',
  function($http, grecaptcha, PublicStorageService, AccessLevel) {
    function httpWithCaptcha(action, { method, url, data, params = {}, responseType = undefined }) {
      let options = {
        method,
        url,
        headers: {
          ...NO_CACHE,
          'x-recaptcha-attempt': 1
        },
        params,
        data: method.toLowerCase() === 'get' ? undefined : data
      };
      if (method.toLowerCase() === 'get' && responseType) options = { ...options, responseType };

      return $http(options).then(
        async response => {
          console.trace('httpWithRecaptcha> First attempt');
          return response;
        },
        async () => {
          let resolve, reject;
          const P = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
          });

          const R = await grecaptcha();
          const { data: recaptchaConfig } = await PublicStorageService.getSiteKeys();

          const key = recaptchaConfig.enterpriseCaptchaKey;

          const executeRecaptcha = () => {
            console.trace('httpWithRecaptcha> Second attempt');
            const executePromise = R.enterprise.execute(key, { action });

            return executePromise.then(function(token) {
              $http({
                ...options,
                headers: {
                  ...options.headers,
                  'x-recaptcha-attempt': 2,
                  'x-recaptcha-token': token,
                  'x-recaptcha-action': action
                }
              }).then(resolve, reject);
            });
          };

          executeRecaptcha();
          return P;
        }
      );
    }

    return (action, { method, url, data, params = {}, responseType = undefined }) => {
      if (AccessLevel.get() !== OPEN) {
        console.trace('Calling $http', { method, url, isLoggedIn: true });
        return $http({ method, url, data, params, responseType, headers: { ...NO_CACHE } });
      } else {
        console.trace('Calling httpWithCaptcha', { action, method, url, isLoggedIn: false });
        return httpWithCaptcha(action, { method, url, data, params, responseType });
      }
    };
  }
]);
